import styled from 'styled-components'

const Container = styled.div`
  padding-bottom: 24px;
`

const TabsContainer = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: 30px;
  border: 1px solid rgba(244, 244, 246, 1);
  border-radius: 8px;
  width: fit-content;
`

const Tab = styled.button<{ active?: boolean }>`
  padding: 15px 40px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ active }) => (active ? '#fff' : 'var(--color-text-black)')};
  background: ${({ active }) => (active ? 'var(--color-button-secondary)' : '#fff')};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  bottom: -1px;
  line-height: 21px;
  /* Directional corners so a sole tab (QCS: Admins only) keeps both radii —
     shorthand :last-child would otherwise override :first-child. */
  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`

const FiltersRow = styled.div`
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
`

const RolesSelectWrap = styled.div`
  min-width: 160px;
`

const StatusSelectWrap = styled.div`
  min-width: 162px;
`

const ManagerSelectWrap = styled.div`
  min-width: 200px;
`

interface SpacingProps {
  mt?: number
}

const PaginationSpacer = styled.div<SpacingProps>`
  margin-top: ${({ mt = 14 }) => mt}px;
`

export { Container, TabsContainer, Tab, FiltersRow, RolesSelectWrap, StatusSelectWrap, ManagerSelectWrap, PaginationSpacer }
